<div class="button-ask-question">
  <div class="button" (click)="openDialog()">Ask a Question</div>
</div>
